import { useCallback } from 'react';
import {
  CategoryID,
  CategoryLocalizedName
} from '../../../../../../categories/categoriesTypes';

import { useReactQueryState } from '../../../../../../common/reactQuery/hooks/useReactQueryState';

import { StockCache } from '../../../../../StockCache';

function useThreeDStockProductsContentCheckedCategories() {
  const { value: checkedCategories, setValue: setCheckedCategories } =
    useReactQueryState<
      { id: CategoryID; localizedName: CategoryLocalizedName }[]
    >(StockCache.checkedProductsCategories(), []);

  const clearCheckedCategories = useCallback<() => void>(() => {
    setCheckedCategories([]);
  }, [setCheckedCategories]);

  return {
    checkedCategories,
    setCheckedCategories,
    clearCheckedCategories
  };
}

export default useThreeDStockProductsContentCheckedCategories;
